export default __webpack_public_path__ + "static/media/covid-sl.d539b6b2.png";